module.exports = __webpack_public_path__ + "img/linha-do-tempo.06dfef62.jpg";